import { AudioSettingsContext, AudioSettingsContextProps } from '@/utils/providers/audioSettingsContext/AudioSettingsContext';
import React, { PropsWithChildren, useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'knowme-narrator-enabled';

export const AudioSettingsProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [isNarratorEnabled, setIsNarratorEnabled] = useState<boolean>(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored !== null ? stored === 'true' : true;
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(isNarratorEnabled));
  }, [isNarratorEnabled]);

  const toggleNarrator = () => {
    setIsNarratorEnabled(prev => !prev);
  };

  const context: AudioSettingsContextProps = useMemo(() => {
    return {
      isNarratorEnabled,
      toggleNarrator,
    };
  }, [isNarratorEnabled]);

  return <AudioSettingsContext.Provider value={context}>{children}</AudioSettingsContext.Provider>;
};
